export class RoleComponentSitemapDto {
  id: number | null;
  roleComponentId: number;
  sitemapId: number;
}
